import moment from "moment";
import { BUSINESS_PRODUCT_TYPE_UPDATED, SCHEME_TYPE_UPDATED } from "../constants/enums";
import { EMAIL_REGEX } from "../constants/regex";

export default function getDocumentType(documents){
    if(documents.document_id === 63){
        if(documents.document_option === "Aadhar - Back"){
            return "Aadhar - Back";
        }else if(documents.document_option === "Aadhar - Front"){
            return "Aadhar - Front";
        }
    }else if(documents.document_id === 65){
        return "Cheque Photo (A/C Verification)";
    }else if(documents.document_id === 2){
        if(documents.document_option === "gst_certificate_1"){
            return "GST Certificate (1)";
        }else if(documents.document_option === "gst_certificate_2"){
            return "GST Certificate (2)";
        }else if(documents.document_option === "gst_certificate_3"){
            return "GST Certificate (3)";
        }
    }else if(documents.document_id === 7){
        return "PAN Card";
    }else if(documents.document_id === 1){
        return "Company PAN";
    }
}

export function leapYear(year)
{
  return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
}

export function getKeyByValue(object, value) {
    let obj = object.toJS()
    return Object.keys(obj).find(key => obj[key] === value);
}

export function splitAndCapitalize(splitBy, str){
    return str
    .split(splitBy) // Split the string by underscores
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); 
}

export function getKeyByValueImmutableMap(immutableMap, value) {
    return immutableMap.findKey((val) => val === value);
}

export function isAscending(arr) {
    return arr.every(function (x, i) {
        return i === 0 || x >= arr[i - 1];
    });
}

export function getSchemeFromBusinessProductType(business_product_type) {
    switch (business_product_type) {
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('INVOICE_FINANCE'):
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('PURCHASE_INVOICE_FINANCE'):
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('SALES_INVOICE_FINANCE'):
            return [
                SCHEME_TYPE_UPDATED.get('DEFAULT_SCHEME'), 
                SCHEME_TYPE_UPDATED.get('COMBINATIONAL_SCHEME'), 
                SCHEME_TYPE_UPDATED.get('RFF_LEVEL_SCHEME'), 
                SCHEME_TYPE_UPDATED.get('PER_UNIT_SUBVENTION_SCHEME'), 
                SCHEME_TYPE_UPDATED.get('SUBVENTION_BASIS_INVOICE_DATE')
            ]
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('VENDOR_FINANCE'):
            return [SCHEME_TYPE_UPDATED.get('VENDOR_FINANCE')]
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('WORKING_CAPITAL_DEMAND_LOAN'):
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('SHORT_TERM_LOAN'):
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('TERM_LOAN'):
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('PERSONAL_TERM_LOAN'):
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('RENOVATION_TERM_LOAN'):
            return [SCHEME_TYPE_UPDATED.get('TERM_LOAN')]
        case BUSINESS_PRODUCT_TYPE_UPDATED.get('CEP'):
            return [SCHEME_TYPE_UPDATED.get('CEP')]

        default: 
            return []
    }
}

export function isFoundersLogin(userEmail){
    return ['pallavi@progcap.com', 'himanshu@progcap.com', 'ravi.shankar@progcap.com', 'badal.huria@progfin.com'].includes(userEmail);
}

export function isEmail(value) {
    return EMAIL_REGEX.test(String(value || "").trim());
}

// Up to two initials from a name, e.g. "Badal Huria" -> "BH"; "?" when blank.
export function initialsOf(name) {
    return (
        String(name || "")
            .trim()
            .split(/\s+/)
            .slice(0, 2)
            .map(w => w.charAt(0).toUpperCase())
            .join("") || "?"
    );
}

// [aStart, aEnd) overlaps [bStart, bEnd) — moment instants.
export function intervalsOverlap(aStart, aEnd, bStart, bEnd) {
    return aStart.isBefore(bEnd) && bStart.isBefore(aEnd);
}

// Next slot boundary from now for the given granularity, e.g.
// nextSlot(30) at 10:12 -> 10:30. Seconds/milliseconds zeroed.
export function nextSlot(slotMinutes) {
    const m = moment();
    const rem = m.minute() % slotMinutes;
    return m.add(slotMinutes - rem, "minutes").second(0).millisecond(0);
}